import React from 'react';

function About() {
  return (
    <div>
      <h1>Sobre nosaltres</h1>
      <p>Aquesta pàgina explica què fem i els nostres serveis.</p>
    </div>
  );
}

export default About;
